import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M22 4.16058H5.85198L5.1109 1.02689C5.03602 0.724389 4.86897 0.45831 4.63696 0.271991C4.40495 0.0856722 4.12164 -0.00990962 3.83317 0.000813208H1C0.5 0.000813208 0 0.5 0 1C0 1.5 0.5 2 1 2H3L6.38862 17.0004C6.4635 17.3029 6.63055 17.569 6.86256 17.7553C7.09457 17.9416 7.37788 18.0372 7.66635 18.0265H19.1659C19.4018 18.0257 19.633 17.954 19.8337 17.8194C20.0344 17.6848 20.1969 17.4925 20.303 17.2639L24.5 7C25 5.5 24.5 4.16058 22 4.16058ZM18.3737 16H8.63742L6.26562 6H22.2069L18.3737 16Z"
                fill="#002856"
            />
            <path
                d="M7.11066 25C8.21523 25 9.11066 24.1045 9.11066 23C9.11066 21.8954 8.21523 21 7.11066 21C6.00609 21 5.11066 21.8954 5.11066 23C5.11066 24.1045 6.00609 25 7.11066 25Z"
                fill="#002856"
            />
            <path
                d="M20 25C21.1046 25 22 24.1046 22 23C22 21.8954 21.1046 21 20 21C18.8954 21 18 21.8954 18 23C18 24.1046 18.8954 25 20 25Z"
                fill="#002856"
            />
        </svg>
    );
};

export default React.memo(Cart);
